import React, { useState } from 'react';
import { textFilter } from 'react-bootstrap-table2-filter';
import { VscNewFile, VscSearch } from 'react-icons/vsc';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import * as type_btn from '../../../../ressources/glossaires/glossaire_type_de_bouton';
import { convertiUtsToDateHour } from '../../../InterfaceClient/Tabs/Alarmes/TableauAlarmesClient/TableauAlarmesClient';
import Bouton from '../../../UI/Bouton/Bouton';
import Tableau from '../../../UI/tableau/Tableau';
import styles from './TableauProjetsTauxCriticite.module.scss';

const TableauProjetsTauxCriticite = ({
  creer,
  sensorList,
  clickSensor,
  children,
}) => {
  const [columns, setColumns] = useState([
    {
      dataField: 'detectionTimestamp',
      text: [
        checkMot('detection_timestamp'),
        <Bouton
          key={'detection_timestamp'}
          type={type_btn.lupeSearch}
          cliquer={() =>
            afficherFiltre(
              'detectionTimestamp',
              checkMot('detection_timestamp')
            )
          }
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
      formatter: (cell) => convertiUtsToDateHour(cell),
    },
    {
      dataField: 'timestampLastValue',
      text: [
        checkMot('timestamp_last_value'),
        <Bouton
          key={'timestamp_last_value'}
          type={type_btn.lupeSearch}
          cliquer={() =>
            afficherFiltre(
              'timestampLastValue',
              checkMot('timestamp_last_value')
            )
          }
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
      formatter: (cell) => convertiUtsToDateHour(cell),
    },
    {
      dataField: 'component',
      text: [
        'Composante(s)',
        <Bouton
          key={'component'}
          type={type_btn.lupeSearch}
          cliquer={() => undefined}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
      formatter: (cell) => {
        const formattedCell = Array.from(cell);
        return formattedCell.join(' | ');
      },
    },
    {
      dataField: 'projectName',
      text: [
        checkMot('project_name'),
        <Bouton
          key={'project_name'}
          type={type_btn.lupeSearch}
          cliquer={() =>
            afficherFiltre('projectName', checkMot('project_name'))
          }
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'sensorName',
      text: [
        checkMot('sensor_name'),
        <Bouton
          key={'sensor_name'}
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('sensorName', checkMot('sensor_name'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'sensorType',
      text: [
        checkMot('sensor_type'),
        <Bouton
          key={'sensor_type'}
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('sensorType', checkMot('sensor_type'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'sensorGroup',
      text: [
        checkMot('sensor_group'),
        <Bouton
          key={'sensor_group'}
          type={type_btn.lupeSearch}
          cliquer={() =>
            afficherFiltre('sensorGroup', checkMot('sensor_group'))
          }
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
  ]);

  const selectRow = {
    mode: 'radio',
    clickToSelect: true,
    hideSelectAll: true,
    hideSelectColumn: true,
    style: () => ({
      background: '#eeb214',
      color: 'black',
    }),
    onSelect: (row) => clickSensor(row.id),
  };

  const iconeCreer = <VscNewFile size={15} />;

  const afficherFiltre = (dataField, placeholder) => {
    const newColumns = columns.map((col) => {
      if (col.dataField === dataField) {
        return {
          ...col,
          filter: textFilter({
            placeholder: placeholder,
          }),
        };
      }
      return col;
    });
    setColumns(newColumns);
  };

  return (
    <>
      <Tableau
        cleLigne={'id'}
        creer={creer}
        iconeCreer={iconeCreer}
        donnees={sensorList}
        colonnes={columns}
        selectionnerLignes={selectRow}
      >
        <span className={styles.refreshForm}>{children}</span>
      </Tableau>
    </>
  );
};

export default TableauProjetsTauxCriticite;
